import { LabelLayer } from "../layers/server/LabelLayer";
import { ThematicLayer } from "../layers/server/ThematicLayer";
import { TileLayer } from "../layers/server/TileLayer";
import { register } from "ol/proj/proj4";
import proj4 from 'proj4';
import { is_grouped } from "../gsa/Config";
export class Loader {
    constructor(config) {
        var _a, _b;
        this.config = config;
        this.min_resolution = (_a = config.MinResolution) !== null && _a !== void 0 ? _a : 0.43402777777777773;
        this.max_resolution = (_b = config.MaxResolution) !== null && _b !== void 0 ? _b : 434.02777777777777;
    }
    register_projections() {
        if (this.config.Projections) {
            Object.getOwnPropertyNames(this.config.Projections).forEach(name => {
                proj4.defs("EPSG:" + name, this.config.Projections[name]);
            });
        }
        proj4.defs("EPSG:2881", "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +to_meter=0.3048006096012192 +no_defs");
        proj4.defs("EPSG:2236", "+proj=tmerc +lat_0=24.33333333333333 +lon_0=-81 +k=0.999941177 +x_0=200000.0001016002 +y_0=0 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs");
        proj4.defs("EPSG:3423", "+proj=tmerc +lat_0=34.75 +lon_0=-118.5833333333333 +k=0.9999 +x_0=800000.0000101599 +y_0=3999999.99998984 +ellps=GRS80 +datum=NAD83 +to_meter=0.3048006096012192 +no_defs");
        proj4.defs("EPSG:3857", "+proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs");
        register(proj4);
    }
    async create_layers() {
        this.register_projections();
        let finals = [];
        const layers = this.config.Layers;
        for (let layer_def of layers) {
            switch (layer_def.type.toLowerCase()) {
                case 'tile':
                    finals.push(new TileLayer(layer_def));
                    break;
                case 'label':
                    finals.push(new LabelLayer(layer_def));
                    break;
                case 'dynamic':
                    layer_def = layer_def;
                    if (is_grouped(layer_def)) {
                        for (let subdef of layer_def.layerGroups) {
                            let modified = {
                                name: subdef.name,
                                infoUrl: layer_def.infoUrl,
                                exportUrl: layer_def.exportUrl,
                                isBaseLayer: layer_def.isBaseLayer,
                                visible: layer_def.visible,
                                opacity: subdef.opacity,
                                details: layer_def.details,
                                group_visible: subdef.visible,
                                group_field: subdef.field,
                                group_as_label: subdef.as_label,
                                group_layers: subdef.layers
                            };
                            finals.push(new ThematicLayer(modified));
                        }
                    }
                    else {
                        finals.push(new ThematicLayer(layer_def));
                    }
                    break;
                default: break;
            }
        }
        let count = 0;
        while (finals.some(l => !l.loaded)) {
            await new Promise(res => setTimeout(res, 20));
        }
        finals.filter(l => l.is_base).forEach(l => {
            l.raw.map(r => r.setZIndex(count++));
        });
        finals.filter(l => l instanceof ThematicLayer).forEach(l => l.raw.map(r => r.setZIndex(count++)));
        finals.filter(l => !l.is_base && !(l instanceof ThematicLayer)).forEach(l => {
            l.raw.map(r => r.setZIndex(count++));
        });
        let baselayer = finals.find(l => l.is_base);
        let base_api = await baselayer.get_service_api();
        this.min_resolution = Math.min(...base_api.cached_resolutions, this.min_resolution);
        this.max_resolution = Math.max(...base_api.cached_resolutions, this.max_resolution);
        return finals;
    }
}
